"use client";

// Keep the existing import contract for all public storefront consumers.
export { default } from "@/shared/real-estate-ui/PublicItemGallery";
